import React, { useEffect, useMemo, useRef, useState } from "react";
import Style from "./style.module.css";

import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import Chip from "../../../../component/ui/chip";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableFooter,
  TableHead,
  TableHeaderWrap,
  TableRow,
  TableSort,
} from "../../../../component/table/table-layout";
import { PlusIcon } from "lucide-react";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import RefundForm from "../../refundForm";
import { ByDate, Source } from "../../../../component/icons/filter-icon";
import { TitleHeading } from "../../../../component/ui/layout";
import UpperTabs from "../../../../component/ui/table/short-filters";

const OrgRefundsBySource = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeader, setTableHeader] = useState([]);

  const [tableFooter, setTableFooter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [currentData, setCurrentData] = useState({});

  const [sortFields, setSortFields] = useState([]);
  const [selectFilterName, setSelectFilterName] = useState("My Filter");
  const [editingFilters, setEditingFilters] = useState(null);


  const [filterDates, setFiltersDates] = useState({});

  const [tabs, setTabs] = useState([]);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
  }, []);



  const handleSingleSort = (field) => {
    setPageCount(1);
    setSortFields((prev) => {
      let currentSort = prev[0]; // Assume prev is an array with max 1 object
      let newSortField;
      if (currentSort && currentSort.field === field) {
        if (currentSort.order === "desc") {
          newSortField = { field, order: "asc" };
        } else if (currentSort.order === "asc") {
          newSortField = null;
        }
      } else {
        newSortField = { field, order: "desc" };
      }
      const finalSortFields = newSortField ? [newSortField] : [];
      // Trigger the filter with the updated sort
      filterData({ sortField: finalSortFields, page: 1 });
      return finalSortFields;
    });
  };

  const filterData = ({
    filters = filterReturn,
    page = pageCount,
    page_quantity = pageItemsCount,
    sortField = sortFields,
    btnCall = false,
  }) => {
    const sort_by = sortField[0]?.field || null;
    const sort_direction = sortField[0]?.order || null;
    const data = {
      page,
      page_quantity,
      filters,
      sort_by,
      sort_direction,
      btnCall,
    };
    getData(data);
  };

  const getData = async (data = null) => {
    if (data?.btnCall) {
      setBtnLoader(true);
    } else {
      setIsLoading(true);
    }
    let urlData = ``;
    if (data) {
      urlData = "?p=1";
      if (data?.filters) {
        data?.filters.forEach((el) => {
          const key = el.field || el.name; // support both
          if (el.selectedOpt === "is" && el.name == "daterange") {
            urlData += `&range=${el.value}`;
          } else if (el?.value !== "" && el?.value != null) {
            urlData += `&${key}=${el.value}`;
          }
        });
      }
      if (data?.sort_by && data?.sort_direction) {
        urlData += `&sort_by=${data.sort_by}&sort_direction=${data.sort_direction}`;
      }
    }

    try {
      let res = await apiCall({
        url: `reports/source-refund${urlData}`,
        method: "get",
      });
      if (data?.btnCall) {
        setBtnLoader(false);
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableFooter(res?.footer);
      setFiltersDates({
        start_date: res?.start_date,
        end_date: res?.end_date,
      });
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTabs(res?.shortcut_filters)
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Err", error);
    }
  };


  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setShowRefund(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "daterange",
      label: "By Date",
      options: ["between", "is"],
      selectedOpt: "between",
      value: "",
      isChecked: true,
      type: "dropdown",
      dropdown: [
        { label: "This Month", value: "this_month" },
        { label: "Last Month", value: "last_month" },
        { label: "This Year", value: "this_year" },
        { label: "Last Year", value: "last_year" },
        { label: "This Quarter", value: "this_quater" },
        { label: "All Time", value: "all_time" },

      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
      Icon: ByDate
    },

    {
      name: "source",
      label: "By Source",
      options: ["contains"],
      selectedOpt: "contains",
      Icon: Source
    },
  ];


  const tableRef = useRef(null);

  const [activeTab, setActiveTab] = useState(null);

  const changeFilter = (val, eachTab) => {

    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filters: updatedFilter });
      } else {
        getData({
          filters: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    setActiveTab(val);
  };

  const filteredData = useMemo(() => {
    if (!activeTab) return apiData;

    return apiData?.filter((eachData) => {
      const fieldValue = eachData?.[activeTab?.header_key];
      const filterValue = activeTab.value;

      if (Array.isArray(fieldValue)) {
        return fieldValue.includes(activeTab?.value);
      }

      if (typeof fieldValue === "string" && fieldValue.includes(",")) {
        return fieldValue
          .split(",")
          .map((item) => item.trim())
          .includes(filterValue);
      }

      return fieldValue === activeTab?.value;
    });
  }, [activeTab, apiData]);


  const [apiApiFilter, setapiApiFilter] = useState(false);

  const innerChange = (eachTab, i) => {
    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        filterData({ filters: updatedFilter });
      } else {
        filterData({
          filters: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    let allTabs = [...tabs];
    allTabs.splice(2, 0, eachTab);
    allTabs.splice(i + 1, 1);
    setTabs(allTabs);
    setActiveTab({ value: eachTab?.value, header_key: eachTab?.header_key });
  };

  return (
    <>
      <div className={`${Style.mainBody}`}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={(!filterReturn?.find(eachFilter => eachFilter?.name == "daterange")?.value?.length) ?
                  [
                    {
                      "name": "daterange",
                      "label": "Date Range",
                      "type": "date",
                      "selectedOpt": "between",
                      "value": [filterDates?.start_date, filterDates?.end_date],
                      "isCrossDisable": true
                    },
                    ...filterReturn
                  ]
                  : filterReturn
                }
                onChange={(filters) => {
                  // console.log("filtersfiltersfilters", filters)
                  setFilterReturn(filters);
                  getData({ filter: filters });
                }}
              />

              {/* HEADER */}
              {/* <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <div>
                    <h1 className="text-xl font-bold pl-3 flex items-center gap-1">
                      Refund By Source
                    </h1>
                  </div>
                </div>

                

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setShowRefund(true);
                      }}
                    >
                      <Tooltip
                        content={"Add Refund"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div> */}

<div className={Style.empDirectory_header}>
                  <div className={Style.empDirectory_header_left}>
                    <div className="flex flex-col gap-1">
                      <TitleHeading title={"Refund By Source"} className={"!pl-0"} />
                      <h3 className="text-gray-500 text-[14px]"> Total Refund</h3>
                    </div>
                  </div>

                  <div className={Style.empDirectory_header_right}>
                    <div className={Style.bpfl_action}>

                      <Tooltip
                        className={Style.bpfl_actionItems}
                        content={"Table Filter"}
                        position={"left center"}
                      >
                        <div
                          className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                            }`}
                          onClick={() => {
                            setShowModalFilterTable(true);
                          }}
                        >
                          <div className={Style.icon}>
                            <FilterFunnel01Icon />
                          </div>
                        </div>
                      </Tooltip>

                      <Tooltip
                        className={`${Style.bpfl_actionItems}`}
                        content={"Customize Table"}
                        position={"left center"}
                      >
                        <div
                          className={`${Style.bpfl_actionBtn}`}
                          onClick={() => {
                            setShowModalCustomizeTabs(true);
                          }}
                        >
                          <div className={Style.icon}>
                            <LayoutTopIcon />
                          </div>
                        </div>
                      </Tooltip>

                      <div className={`
                        bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                        hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                        
                        py-[10px] px-[12px] rounded-[5px] text-center 
                        text-[#fff] text-[12px] font-semibold text-nowrap 
                        flex items-center justify-center transition-all
                        gap-1
                        cursor-pointer
                      `}
                        onClick={() => {
                          setShowRefund(true);
                        }}
                      >
                        <PlusIcon size={"1em"} />
                        Add Refund
                      </div>
                    </div>
                  </div>
                </div>

                {apiData.length > 0 && !isLoading ? (
                  <UpperTabs
                    activeTab={activeTab}
                    setActiveTab={changeFilter}
                    upparTabs={tabs?.length ? tabs : []}
                    totalEmp={apiData?.length}
                    userData={apiData}
                    // DepartmentIcons={leadUpperTabIcons}
                    onInnerChange={innerChange}
                    isAllFilterShow={true}
                    upparTabsLimite={5}
                    UpparAllIcon={null}
                  />
                ) : null}

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Refund"} />
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky className={"min-w-[250px] max-w-[250px]"}>
                              <TableHeaderWrap>
                                <span>Source</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell className={"min-w-[150px] max-w-[150px] !left-[250px]"} header sticky>
                              <TableHeaderWrap>
                                <span>Total Cases</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell className={"!left-[400px]"} header sticky>
                              <TableHeaderWrap>
                                <span>Total Loss</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                    {eachHead?.sort_by ? (
                                      <TableSort
                                        field={eachHead?.key}
                                        sortFields={sortFields}
                                        onSort={handleSingleSort}
                                        Style={Style}
                                      />
                                    ) : (
                                      <TableSort
                                        disabled={true}
                                        field={eachHead?.key}
                                        Style={Style}
                                      />
                                    )}
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {(apiApiFilter ? apiData : filteredData)?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5">
                                        {eachList?.source ?? "-"}
                                      </div>
                                    </div>

                                    {/* <div
                                      className={Style.tableActionAreaBtnGrpup}
                                    >
                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                        onClick={() => {
                                          editRefund(eachList);
                                        }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#FF9500" }}
                                        >
                                          <NewEditIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        }
                                      // onClick={() => {
                                      //   setEmpPopup(true);
                                      //   setEmpData(eachList);
                                      // }}
                                      >
                                        <div
                                          className={Style.icon}
                                          style={{ color: "#007AFF" }}
                                        >
                                          <NewEyeIcon className="h-4.5 w-4.5" />
                                        </div>
                                      </div>
                                    </div> */}
                                  </div>
                                </TableCell>

                                <TableCell className={"!left-[250px]"} sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5 whitespace-pre-wrap break-all">
                                        {eachList?.loss_count ?? "-"}
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                <TableCell className={"!left-[400px]"} sticky>
                                  {/* {eachList?.client_name ?? "-"} */}

                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    <div className="flex items-center gap-3">
                                      <div className="font-medium leading-5">
                                        {eachList?.loss_amount ?? "-"}
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                    <TableCell key={`${i}-${index}`} isDim={eachHead?.dim_text === 1}>
                                      {eachList?.[eachHead?.key] ?? "-"}
                                    </TableCell>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>

                        <TableFooter>
                          <TableRow>
                            <TableCell
                              sticky
                              header
                              className="text-gray-800 font-bold tracking-wide uppercase"
                            >
                              Summary
                            </TableCell>

                            <TableCell
                              sticky
                              header
                              className={"!left-[250px]"}
                            >
                              {tableFooter?.loss_count ?? "--"}
                            </TableCell>

                            <TableCell
                              sticky
                              header
                              className={"!left-[400px]"}
                            >
                              {tableFooter?.loss_amount ?? "--"}
                            </TableCell>

                            {tableHeader.map((h_ele, h_idx) =>
                              h_ele.is_visible === 1 &&
                                h_ele?.show == 1 ? (
                                <TableCell
                                  header
                                  key={`tf-${h_idx}`}
                                  className={`${h_ele?.type === "number"
                                    ? "!text-end font-number"
                                    : ""
                                    } ${h_ele?.key === "credit"
                                      ? "!text-green-600 font-semibold"
                                      : h_ele?.key === "debit"
                                        ? "!text-red-600 font-semibold"
                                        : ""
                                    }`}
                                >
                                  {tableFooter[h_ele?.key] ?? "--"}
                                </TableCell>
                              ) : null)}
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  {/* <div className={Style.table_footer_left}>
                    {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                      }`}
                  </div> */}

                  {tablePagination ? (
                    <div className={Style.empDirectory_footer}>
                      {tablePagination?.next_page_url ? (
                        <button
                          className={Style.loadMoreBtn}
                          onClick={() => {
                            if (btnLoader) return;
                            setPageCount(pageCount + 1);
                            setBtnLoader(true);
                            filterData({ page: pageCount + 1, btnCall: true });
                            // getData({
                            //   page: tablePagination?.next_page_url,
                            // });
                          }}
                        >
                          {btnLoader ? (
                            <InnerLoader
                              className={Style.loader}
                              textStatus={false}
                            />
                          ) : (
                            "Load More"
                          )}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          // onSave={(filters, filterName, editingFilter) => {
          //   getData({ filter: filters });
          //   setShowModalFilterTable(false);
          //   setFilterReturn(filters);
          // }}
          saveFilter={saveFilter}
          apiUrl="source-refund"
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters ? filters : []);
            setSelectFilterName(filterName ? filterName : "My Filter");
            setEditingFilters(editingFilter ? editingFilter : []);
            setPageCount(1);
            filterData({ filters: filters, page: 1 });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="source-refund"
        />
      )}

      {showRefund && (
        <RefundForm
          onError={onError}
          onSubmit={onSuccess}
          onClose={() => {
            setShowRefund(false);
            setCurrentData({});
          }}
          refundDataId={currentData}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrgRefundsBySource;
